import React from "react";
import { connect } from "react-redux";
// import { Modal } from "bootstrap";

const StoreModal = ({Store, setStore}) => {
    const updatefield = (e) => {
        setStore((prevStore) => ({...prevStore, [e.target.name]: e.target.value}));
    }
    return (
        <div id="storemodal" class="modal animated fadeInUp custo-fadeInUp" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"><span>Create</span> store</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        {/* <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                        </button> */}
                    </div>
                    <div class="modal-body">
                        <form data-model="Product" id="captureform">
                            <div class="form-group">
                                <label for="storemodal_name_input">Name</label>
                                <input type="text" class="form-control" name="name" id="storemodal_name_input" value={Store?.name} onChange={updatefield}/>
                            </div>
                            <div class="form-group">
                                <label for="storemodal_phone_input">Phone</label>
                                <input type="text" class="form-control" name="phone" id="storemodal_phone_input" value={Store?.phone} onChange={updatefield}/>
                            </div>
                            <div class="form-group">
                                <label for="storemodal_email_input">Email</label>
                                <input type="text" class="form-control" name="email" id="storemodal_email_input" value={Store?.email} onChange={updatefield}/>
                            </div>
                            <div class="form-group">
                                <label for="storemodal_gst_input">GST</label>
                                <input type="text" class="form-control" name="gst" id="storemodal_gst_input" value={Store?.gst} onChange={updatefield} />
                            </div>
                            {/* <div class="form-group">
                                <label for="storemodal_code_input">Store Code</label>
                                <input type="text" class="form-control" name="code" id="storemodal_code_input" value={Store?.store_code} />
                            </div> */}
                        </form>
                    </div>
                    <div class="modal-footer md-button">
                        <button class="btn" data-bs-dismiss="modal"><i class="flaticon-cancel-12"></i> Discard</button>
                        <button type="button" id="captureformbutton" class="btn btn-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default connect(null, {})(StoreModal);